export default {

  /**
   * describe: 数组对象自定义排序
   *
   * @Param: {data:[数据],sortBy:['第一个展示的值','第二个展示的值','第三个展示的值'],sortField:'字段名'}
   * @Return:
   * @Author: Aaron
   * @Date: 2022/5/28 14:45
   */
  objectListSort({data, sortBy, sortField}) {
    const sortByObject = sortBy.reduce(
        (obj, item, index) => ({
          ...obj,
          [item]: index
        }),
        {}
    );
    return data.sort(
        (a, b) => sortByObject[a[sortField]] - sortByObject[b[sortField]]
    );
  },
  arraySort(data, sortField, isAsc) {
    if (isAsc) {
      return data.sort((obj1, obj2) => obj2[sortField] - obj1[sortField]);
    }
    return data.sort((obj1, obj2) => obj1[sortField] - obj2[sortField]);
  },
}